import React, { useState } from 'react';

import {
	BottomCard,
	BottomCardAction,
	BottomCardForm,
} from '@/components/shared/BottomCard';
import { AsaphButton } from '@/components/shared/Button';
import { SettingCard } from '@/components/shared/SettingCard';
import { useAuth } from '@/providers/AuthProvider';
import { useIntercom } from '@/providers/IntercomProvider/IntercomProvider';
import { Divider, List } from '@material-ui/core';

import { AccountDisplayProps, EAccountDisplayState } from '../AccountPanel';

export const SettingAccount: React.FC<AccountDisplayProps> = ({
	pushDisplayState,
}) => {
	const { user } = useAuth();
	const { openIntercom } = useIntercom();
	const [emailSheetOpen, setEmailSheetOpen] = useState(false);

	return (
		<div className="p-lg">
			<List>
				<SettingCard
					type="setting"
					title="Email"
					orderPosition="only"
					trailingText={user.email}
					onClick={() => setEmailSheetOpen(true)}
				/>
			</List>
			<Divider />
			<List>
				<SettingCard
					id="intercom"
					type="setting"
					title="Delete account"
					onClick={() =>
						pushDisplayState(EAccountDisplayState.DELETE_ACCOUNT)
					}
					red
					noChevron
				/>
			</List>
			<Divider />

			{emailSheetOpen && (
				<BottomCard
					title="Edit email"
					onClose={() => setEmailSheetOpen(false)}
					hasCloseButton
				>
					<BottomCardForm>
						To update your email address, please contact support.
					</BottomCardForm>
					<BottomCardAction>
						<AsaphButton
							color="blue"
							label="Contact Support"
							onClick={() => {
								setEmailSheetOpen(false);
								openIntercom();
							}}
							fullWidth
						/>
					</BottomCardAction>
				</BottomCard>
			)}
		</div>
	);
};
